module.exports = __webpack_public_path__ + "img/3_kmart-pouch.ded4a894.jpg";